import i18n from "i18next";
import { ClassOptionsGrid } from "@/components/shared/ClassOptionsGrid/ClassOptionsGrid";
import type { ClassOptionsValue } from "@/types/documentClass";
import styles from "../DocumentStamp.module.scss";

export interface ClassOptionsSectionProps {
  value: ClassOptionsValue;
  onChange: (next: ClassOptionsValue) => void;
  /** Read-only mode — render but don't accept changes. */
  disabled?: boolean;
}

/**
 * Section 2 of the popover — "Class options".
 *
 * Wraps Team 5's `<ClassOptionsGrid />`. Six segmented controls in a
 * 2-column grid (page size, font size, columns, sides, orientation,
 * title page) plus the conditional "Balance at end" checkbox that
 * appears when columns === 2.
 */
export function ClassOptions({ value, onChange, disabled }: ClassOptionsSectionProps) {
  return (
    <div className={styles.section} data-testid="document-stamp-class-options">
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>{i18n.t("editor:stamp.classOptions")}</span>
        {disabled && <span className={styles.readOnlyPip}>{i18n.t("editor:stamp.readOnly")}</span>}
      </div>

      <div className={disabled ? styles.muted : undefined}>
        <ClassOptionsGrid value={value} onChange={onChange} />
      </div>
    </div>
  );
}
